import { HStack, Image, VStack } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type ItemProps = {
  label: string;
  variant?: 'normal' | 'highlight' | 'footer';
  description?: string;
  icon?: keyof typeof IconMap;
  image?: string;
  value: string;
};

export const Item: React.FC<ItemProps> = ({ description, icon, variant = 'normal', image, label, value }) => {
  return (
    <HStack
      backgroundColor={variant === 'footer' ? 'rgba(0,0,0,0.05)' : 'transparent'}
      boxSizing="border-box"
      borderTopWidth="1px"
      borderTopStyle="solid"
      borderTopColor="blackAlpha.100"
      borderBottomRadius={variant === 'footer' ? '15px' : '0px'}
      display="flex"
      justifyContent={'space-between'}
      padding="20px 0"
      flexDirection="row"
      alignItems={'flex-start'}
      width="full">
      <HStack paddingLeft="20px" gap="10px">
        {image && <Image src={image} width={'60px'} height={'50px'} borderRadius="5px" />}
        {icon && <Icon icon={icon} boxSize={['24px']} color="blue.500" />}
        <VStack alignItems={'flex-start'} spacing={0} gap={0}>
          <TextBlock
            fontFamily={variant === 'highlight' ? FontFamily.HELVETICA_NOW_BOLD : FontFamily.HELVETICA_NOW_REGULAR}>
            {label}
          </TextBlock>
          {description && (
            <TextBlock color="grey" fontSize={'16px'}>
              {description}
            </TextBlock>
          )}
        </VStack>
      </HStack>
      <TextBlock as="div" weight="bold" paddingRight="20px" textAlign="right">
        {value}
      </TextBlock>
    </HStack>
  );
};
